import React, { useState } from "react";

const Header = () => {
  const [openMenu, setOpenMenu] = useState(null);

  const handleMouseEnter = (menu) => {
    setOpenMenu(menu);
  };

  const handleMouseLeave = () => {
    setOpenMenu(null);
  };

  return (
    <div>
      {/* NAVBAR START HERE */}
      <nav className="navbar trust-nav navbar-expand-md navbar-light">
        <div className="container d-flex align-items-center">
          <a className="navbar-brand" href="/">
            <img src="/assets/img/logo.webp" alt="Logo" />
          </a>
          <button
            className="navbar-toggler d-md-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li
                className="nav-item dropdown position-static"
                onMouseEnter={() => handleMouseEnter("services")}
                onMouseLeave={handleMouseLeave}
              >
                <a
                  className="nav-link dropdown-toggle"
                  href="/services/"
                  id="navbarDropdownLocations"
                  role="button"
                  aria-expanded={openMenu === "services"}
                  onClick={(e) => {
                    if (openMenu === "services") {
                      return;
                    }
                    e.preventDefault();
                    handleMouseEnter("services");
                  }}
                >
                  Services
                </a>
                {openMenu === "services" && (
                  <div
                    className="dropdown-menu dropd-menu mt-0 show"
                    aria-labelledby="navbarDropdown"
                  >
                    <div className="container">
                      <div className="row my-4">
                        <div className="col-md-12 col-xl-3 col-lg-6 mb-1 mb-lg-0">
                          <div className="list-group list-group-flush">
                            <a
                              href="/services/apartment-cleanout/"
                              className="list-group-item list-group-item-action"
                            >
                              Apartment Cleanout
                            </a>
                            <a
                              href="/services/appliance-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Appliance Removal
                            </a>
                            <a
                              href="/services/attic-cleanout/"
                              className="list-group-item list-group-item-action"
                            >
                              Attic Cleanout
                            </a>

                            <a
                              href="/services/cardboard-pickup/"
                              className="list-group-item list-group-item-action"
                            >
                              Cardboard Pickup
                            </a>
                            <a
                              href="/services/carpet-disposal/"
                              className="list-group-item list-group-item-action"
                            >
                              Carpet Disposal
                            </a>
                            <a
                              href="/services/concrete-pickup/"
                              className="list-group-item list-group-item-action"
                            >
                              Concrete Removal
                            </a>
                          </div>
                        </div>
                        <div className="col-md-12 col-xl-3 col-lg-6 mb-1 mb-lg-0">
                          <div className="list-group list-group-flush">
                            <a
                              href="/services/construction-debris-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Construction Debris Removal
                            </a>
                            <a
                              href="/services/deck-demolition/"
                              className="list-group-item list-group-item-action"
                            >
                              Deck Removal
                            </a>

                            <a
                              href="/services/electronic-junk-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Electronics Recycling
                            </a>
                            <a
                              href="/services/estate-cleanout/"
                              className="list-group-item list-group-item-action"
                            >
                              Estate cleanout
                            </a>
                            <a
                              href="/services/fencing-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Fencing Removal
                            </a>
                          </div>
                        </div>
                        <div className="col-md-12 col-xl-3 col-lg-6 mb-1 mb-lg-0">
                          <div className="list-group list-group-flush">
                            <a
                              href="/services/foreclosure-cleanout/"
                              className="list-group-item list-group-item-action"
                            >
                              Foreclosure Cleanout
                            </a>
                            <a
                              href="/services/furniture-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Furniture Removal
                            </a>
                            <a
                              href="/services/garage-cleanout/"
                              className="list-group-item list-group-item-action"
                            >
                              Garage Cleanout
                            </a>
                            <a
                              href="/services/hoarder-cleanup/"
                              className="list-group-item list-group-item-action"
                            >
                              Hoarder Cleanout
                            </a>
                            <a
                              href="/services/hot-tub-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Hot Tub Removal
                            </a>

                            <a
                              href="/services/office-cleanout/"
                              className="list-group-item list-group-item-action"
                            >
                              Office Cleanout
                            </a>
                          </div>
                        </div>
                        <div className="col-md-12 col-xl-3 col-lg-6 mb-1 mb-lg-0 rmv-drop-menu">
                          <div className="list-group list-group-flush">
                            <a
                              href="/services/piano-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Piano Removal
                            </a>
                            <a
                              href="/services/swing-set-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Playset Removal
                            </a>

                            <a
                              href="/services/scrap-metal-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Scrap Metal Removal
                            </a>
                            <a
                              href="/services/shed-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Shed Removal
                            </a>
                            <a
                              href="/services/storage-unit-cleanouts/"
                              className="list-group-item list-group-item-action"
                            >
                              Storage Unit Cleanout
                            </a>

                            <a
                              href="/services/yard-waste-removal/"
                              className="list-group-item list-group-item-action"
                            >
                              Yard Waste Removal
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              <li
                className="nav-item dropdown position-static"
                onMouseEnter={() => handleMouseEnter("locations")}
                onMouseLeave={handleMouseLeave}
              >
                <a
                  className="nav-link dropdown-toggle"
                  href="/locations/"
                  id="navbarDropdownLocations"
                  role="button"
                  aria-expanded={openMenu === "locations"}
                  onClick={(e) => {
                    if (openMenu === "locations") {
                      return;
                    }
                    e.preventDefault();
                    handleMouseEnter("locations");
                  }}
                >
                  Locations
                </a>
                {openMenu === "locations" && (
                  <div
                    className="dropdown-menu location-drop dropd-menu mt-0 show"
                    aria-labelledby="navbarDropdown"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="container">
                      <div className="row my-4">
                        <div className="col-md-12 col-xl-3 col-lg-6 mb-1 mb-lg-0">
                          <div className="list-group list-group-flush">
                            <a
                              href="/campbellca/"
                              className="list-group-item list-group-item-action"
                            >
                              Campbell
                            </a>
                            <a
                              href="/cupertinoca/"
                              className="list-group-item list-group-item-action"
                            >
                              Cupertino
                            </a>
                            <a
                              href="/fremontca/"
                              className="list-group-item list-group-item-action"
                            >
                              Fremont
                            </a>
                            <a
                              href="/losaltosca/"
                              className="list-group-item list-group-item-action"
                            >
                              Los Altos
                            </a>
                          </div>
                        </div>
                        <div className="col-md-12 col-xl-3 col-lg-6 mb-1 mb-lg-0">
                          <div className="list-group list-group-flush">
                            <a
                              href="/losgatosca/"
                              className="list-group-item list-group-item-action"
                            >
                              Los Gatos
                            </a>
                            <a
                              href="/milpitasca/"
                              className="list-group-item list-group-item-action"
                            >
                              Milpitas
                            </a>
                            <a
                              href="/mountainviewca/"
                              className="list-group-item list-group-item-action"
                            >
                              Mountain View
                            </a>
                            <a
                              href="/newarkca/"
                              className="list-group-item list-group-item-action"
                            >
                              Newark
                            </a>
                          </div>
                        </div>
                        <div className="col-md-12 col-xl-3 col-lg-6 mb-1 mb-lg-0">
                          <div className="list-group list-group-flush">
                            <a
                              href="/paloaltoca/"
                              className="list-group-item list-group-item-action"
                            >
                              Palo Alto
                            </a>
                            <a
                              href="/sanjoseca/"
                              className="list-group-item list-group-item-action"
                            >
                              San Jose
                            </a>
                            <a
                              href="/santaclaraca/"
                              className="list-group-item list-group-item-action"
                            >
                              Santa Clara
                            </a>
                            <a
                              href="/saratogaca/"
                              className="list-group-item list-group-item-action"
                            >
                              Saratoga
                            </a>
                          </div>
                        </div>
                        <div className="col-md-12 col-xl-3 col-lg-6 mb-1 mb-lg-0">
                          <div className="list-group list-group-flush">
                            <a
                              href="/sunnyvaleca/"
                              className="list-group-item list-group-item-action"
                            >
                              Sunnyvale
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>

              <li className="nav-item">
                <a className="nav-link" href="/pricing/">
                  Pricing
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/contact-us/">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* NAVBAR END HERE */}
    </div>
  );
};

export default Header;
